var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.resourceListPage,_vm._b({ref:"listComponent",tag:"component"},'component',_vm.attributes,false))}
var staticRenderFns = []

export { render, staticRenderFns }